import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ffa64b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "avatar-uploader image-container d-flex align-items-center justify-content-center"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "image-overlay" }

import { ref, watch } from "vue";
import type {
  UploadInstance,
  UploadProps,
  UploadRawFile,
  UploadUserFile,
} from "element-plus";
import EventServices from "../../services/EventsServices";
import { ElMessage } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Delete, Plus, ZoomIn } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImage',
  setup(__props, { expose: __expose }) {

const file = ref<UploadRawFile>();
const fileList = ref<UploadUserFile[]>();
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const imageUrls = ref<any>([]);
const uploading = ref(false);
const uploadRef = ref<UploadInstance>();
const imageUrl = ref("");
const type = ref("cover");
const uploadImage = async () => {
  const formData = new FormData();
  if (file.value === undefined) {
    return;
  }
  formData.append("file", file.value);
  try {
    const res = await EventServices.uploadImage(formData);
    imageUrls.value = [res.url];
  } catch (error) {
    MsgPrompt.error("Upload file failed, file too large or invalid format");
  }
};

const beforeAvatarUpload: UploadProps["beforeUpload"] = (rawFile) => {
  if (
    rawFile.type !== "image/jpeg" &&
    rawFile.type !== "image/jpg" &&
    rawFile.type !== "image/png"
  ) {
    fileList.value = [];
    ElNotification.error("Avatar picture must be JPG/JPEG/PNG format!");
    return false;
  } else if (rawFile.size / 1024 / 1024 > 10) {
    fileList.value = [];
    ElNotification.error("Avatar picture size can not exceed 10MB!");
    return false;
  }
  file.value = rawFile;
  if (rawFile) {
    imageUrl.value = URL.createObjectURL(rawFile);
  } else {
    // Handle the case when rawFile is null or undefined
    console.error("rawFile is null or undefined");
    fileList.value = [];
  }
  return true;
};

const handlePreview = () => {
  dialogImageUrl.value = imageUrl.value;
  dialogVisible.value = true;
};

const handleRemove = () => {
  fileList.value = [];
};

watch(fileList, (newVal) => {
  if (newVal) {
    if (newVal.length === 0) {
      imageUrl.value = "";
      return;
    }
    beforeAvatarUpload(newVal[0].raw as UploadRawFile);
  }
});

__expose({
  uploadImage,
  imageUrl,
  imageUrls,
  uploading,
  handleRemove,
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      _withDirectives(_createVNode(_component_el_upload, {
        ref_key: "uploadRef",
        ref: uploadRef,
        class: "avatar-uploader",
        "before-upload": beforeAvatarUpload,
        action: "#",
        "auto-upload": false,
        "show-file-list": false,
        "file-list": fileList.value,
        "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["file-list"]), [
        [_vShow, !imageUrl.value]
      ]),
      (imageUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: imageUrl.value,
              class: "avatar"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_icon, {
                  class: "fs-2x text-white",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePreview()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ZoomIn))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_icon, {
                  class: "fs-2x text-white",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRemove()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Delete))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, uploading.value]
    ]),
    _createElementVNode("div", null, [
      (dialogVisible.value)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "url-list": [dialogImageUrl.value],
            onClose: _cache[3] || (_cache[3] = ($event: any) => (dialogVisible.value = false))
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})